export default __webpack_public_path__ + "static/media/agid-login-logo-white.40b2669d.svg";